import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  AmenitiesListInterior as BaseAmenitiesListInterior,
  contentSchema as baseSchema,
} from '@vibesites/theme-via6/components/AmenitiesListInterior';

/**
 * The Majestic — AmenitiesListInterior override (interior amenities row).
 *
 * Companion to `AmenitiesListCommunity`. Wraps the Weidner Via6 base
 * component and layers the same two brand tweaks, both of which live inside
 * the parent's opaque JSX tree (the shared `_AmenitiesListRow` helper), so a
 * CSS style wrapper is the cheapest override that reaches them:
 *
 *   1. Capitalize only the FIRST letter of each amenity list item (sentence
 *      case) via a `::first-letter` rule on the item's text span (promoted to
 *      inline-block so `::first-letter` applies), leaving the rest of the
 *      title's casing untouched.
 *   2. Hide the "Amenities will be displayed here." empty-state placeholder
 *      (`.weidner-amenities-row-empty`).
 *
 * Both selectors are scoped to `[data-weidner-amenities-row]` — the stable
 * data-attribute the shared row section carries.
 *
 * The base schema travels with us via the re-attach below — without it the
 * editor would show no editing affordances on the wrapper.
 */
export function AmenitiesListInterior() {
  return (
    <>
      <BaseAmenitiesListInterior />
      <style>{`
        /* Capitalize only the FIRST letter of each amenity item (sentence
           case), leaving the rest of the title's casing untouched.
           ::first-letter needs a block container, so the text span (the
           last child of the flex <li>; the preceding bullet span is
           display:none) is promoted to inline-block. */
        [data-weidner-amenities-row] .amenities-col-item span:last-child {
          display: inline-block;
        }
        [data-weidner-amenities-row] .amenities-col-item span:last-child::first-letter {
          text-transform: uppercase;
        }
        [data-weidner-amenities-row] .weidner-amenities-row-empty {
          display: none !important;
        }
      `}</style>
    </>
  );
}

(AmenitiesListInterior as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  baseSchema;

export default AmenitiesListInterior;
